import { render, staticRenderFns } from "./SuperLink.vue?vue&type=template&id=39a8e6f4"
import script from "./SuperLink.vue?vue&type=script&lang=js"
export * from "./SuperLink.vue?vue&type=script&lang=js"
import style0 from "./SuperLink.vue?vue&type=style&index=0&id=39a8e6f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports